export default __webpack_public_path__ + "static/media/job_offer5_xl.38bbe639.jpg";